import styled from "styled-components";
import Heading from "@vfuk/core-heading";
import InitialsAvatar from "@vfuk/core-initials-avatar";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import Link from "@vfuk/core-link";
import Container from "@vfuk/core-container";
import { useProfileModal } from "./hooks/useProfileModal";
import ReturnStep from "./ReturnStep";

const CenteredDiv = styled.div`
  text-align: center;
  vertical-align: middle;
  width: auto;
`;

const ProfileEdit = () => {
  const { setView, navbarUser } = useProfileModal();
  const { email, initials, name } = navbarUser;

  return (
    <Container appearance="primary">
      <ReturnStep onBack={() => setView("VIEW_PROFILE")} />
      <Spacing
        spacingLevel={{
          top: 3,
        }}
      >
        <Heading level={5} size={1} weight={3}>
          Profile management
        </Heading>

        <Paragraph justify="left">
          <CenteredDiv>
            <Spacing
              spacingLevel={{
                top: 3,
                bottom: 3,
              }}
            >
              <InitialsAvatar initials={initials} size={6} />
            </Spacing>
            <Heading
              size={1}
              level={3}
              weight={3}
              justify="center"
              text={name}
            />
          </CenteredDiv>
          <Spacing
            spacingLevel={{
              top: 6,
            }}
          >
            <Heading
              size={1}
              level={3}
              weight={3}
              justify="left"
              text="Registered email"
            />
            {email}
          </Spacing>
          <Spacing
            spacingLevel={{
              top: 6,
              bottom: 6,
            }}
          >
            <Link
              onClick={() => setView("CHANGE_PASSWORD")}
              text="Change password"
              showUnderline={true}
            />
          </Spacing>
        </Paragraph>
      </Spacing>
    </Container>
  );
};

export default ProfileEdit;
